export enum CanvasTypeOptions {
	BLANK = 0,
	SHARED = 1,
	DUPLICATE = 2,
}
